import LinkedinBoxLineIcon from 'remixicon-react/LinkedinBoxLineIcon';
import GithubLineIcon from 'remixicon-react/GithubLineIcon';
import FileTextLineIcon from 'remixicon-react/FileTextLineIcon';
import SendPlaneLineIcon from 'remixicon-react/SendPlaneLineIcon';
import Headshot from '../../../assets/headshot_fox.jpeg';
import Resume from '../../../assets/Kyle_Moreau_Resume.pdf';
import Reveal from '../../Reveal';

const socialLinks = [
  {
    href: 'https://www.linkedin.com/in/kyle-moreau/',
    label: 'LinkedIn',
    Icon: LinkedinBoxLineIcon,
  },
  {
    href: 'https://github.com/notkylemoreau98',
    label: 'GitHub',
    Icon: GithubLineIcon,
  },
  {
    href: Resume,
    label: 'Resume',
    Icon: FileTextLineIcon,
  },
];

const Hero = () => {
  return (
    <section
      className='relative px-5 pt-16 pb-24 md:px-10 lg:px-20 md:pt-24 md:pb-32 overflow-hidden'
      id='home'
    >
      <div
        className='pointer-events-none absolute -top-32 right-[-10%] h-[420px] w-[420px] rounded-full bg-accent/20 blur-[110px]'
        aria-hidden='true'
      />
      <div
        className='pointer-events-none absolute top-40 left-[-15%] h-[320px] w-[320px] rounded-full bg-accent/10 blur-[100px]'
        aria-hidden='true'
      />

      <div className='relative max-w-[1150px] mx-auto flex flex-col-reverse md:flex-row items-center gap-14 md:gap-16'>
        <div className='flex-1 text-center md:text-left'>
          <Reveal>
            <p className='font-mono text-xs md:text-sm tracking-[0.25em] uppercase text-accent mb-5'>
              Full-Stack Software Engineer
            </p>
          </Reveal>

          <Reveal delay={80}>
            <h1 className='font-serif text-6xl md:text-7xl lg:text-8xl font-semibold text-ink leading-[0.95] tracking-tight'>
              Kyle
              <br />
              Moreau
            </h1>
          </Reveal>

          <Reveal delay={160}>
            <p className='mt-7 text-lg text-ink/70 leading-8 max-w-[500px] mx-auto md:mx-0'>
              I build web platforms that are fast, reliable, and don't fall
              over under real traffic. Most of my time these days goes
              toward performance and clean architecture — the unglamorous
              stuff that actually matters.
            </p>
          </Reveal>

          <Reveal delay={240}>
            <div className='flex flex-col sm:flex-row items-center gap-4 mt-10 justify-center md:justify-start'>
              <a
                href='#contact'
                className='group inline-flex items-center gap-2 bg-ink text-paper py-3 px-6 rounded-full font-medium transition-all duration-300 hover:bg-accent hover:-translate-y-0.5 hover:shadow-[0_12px_24px_-8px_rgba(67,56,202,0.5)]'
              >
                <SendPlaneLineIcon size={18} /> Get in Touch
              </a>
              <a
                href={Resume}
                target='_blank'
                rel='noopener noreferrer'
                className='inline-flex items-center gap-2 border border-ink/20 text-ink py-3 px-6 rounded-full font-medium transition-all duration-300 hover:border-ink hover:-translate-y-0.5'
              >
                Download Résumé
              </a>
            </div>

            <div className='flex items-center gap-4 mt-9 justify-center md:justify-start'>
              {socialLinks.map(({ href, label, Icon }) => (
                <a
                  key={label}
                  href={href}
                  target='_blank'
                  rel='noopener noreferrer'
                  aria-label={label}
                  className='h-10 w-10 flex items-center justify-center rounded-full border border-ink/15 text-ink/60 transition-all duration-300 hover:text-accent hover:border-accent hover:-translate-y-0.5'
                >
                  <Icon size={20} />
                </a>
              ))}
            </div>
          </Reveal>
        </div>

        <Reveal delay={120} className='flex-shrink-0'>
          <div className='relative'>
            <div
              className='pointer-events-none absolute inset-0 -z-10 rounded-full bg-accent/25 blur-3xl scale-110'
              aria-hidden='true'
            />
            <img
              className='relative w-60 h-60 md:w-80 md:h-80 rounded-full object-cover border border-ink/10 shadow-[0_20px_50px_-20px_rgba(23,23,23,0.3)]'
              src={Headshot}
              alt='Kyle Moreau'
            />
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default Hero;
